<template>
  <v-container lg4 fluid grid-list-md>
    <v-layout align-center justify-space-around row wrap>
      <v-flex d-flex xs12 sm5 md3 lg3 v-for="contact in contacts" :key="contact.name">
        <v-card>
          <v-card-text>
            <h4 class="text-xs-center">{{ contact.name }}</h4>
            <v-divider insert></v-divider>
            <ul>
              <li>
                <a href="mailto: contact.email">{{ contact.email }}</a>
              </li>
              <li style="text-decoration:none;">{{ contact.phone }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ContactCards',
  data() {
    return {
      contacts: [
        {
          name: 'Dan McDade',
          email: 'Daniel.R.McDade@gmail.com',
          phone: '(617) 633-6612',
        },
        {
          name: 'Anan Liu',
          email: 'stephanieliuu@gmail.com',
          phone: '(814) 954-2826',
        },
      ],
    };
  },
  computed: {
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true;
      return binding;
    },
  },
};
</script>

<style scoped></style>
